import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function ContentSection() {
  const authors = ['Brian Tracy', 'Napoleon Hill', 'Tony Robbins', 'Robert Kiyosaki', 'Stephen Covey', 'Viktor Frankl', 'James Clear', 'Deepak Chopra', 'Joe Dispenza'];
  return <section className="py-10 px-4 bg-[#1A1A2E] text-center border-t border-gray-800" data-id="element-61">
      <div className="max-w-4xl mx-auto" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-63">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-64">
            📘 ¿Qué incluye exactamente la biblioteca?
          </h2>

          <p className="text-lg md:text-xl font-bold text-gray-400 mb-8" data-id="element-65">
            Una de las colecciones más completas de desarrollo personal en
            español.
          </p>

          <p className="text-xl font-black mb-5 text-white" data-id="element-66">
            Dentro encontrarás:
          </p>

          <div className="flex flex-col md:flex-row justify-center gap-4 mb-8" data-id="element-67">
            <div className="bg-gray-900 p-6 rounded-2xl border border-gray-800 shadow-lg transform hover:-translate-y-1 transition-transform w-full md:w-1/2" data-id="element-68">
              <div className="text-5xl mb-3" data-id="element-69">🎧</div>
              <h3 className="text-4xl font-black text-[#8FF650] mb-1" data-id="element-70">2.000</h3>
              <p className="text-lg font-bold text-white uppercase" data-id="element-71">
                Audiolibros
              </p>
            </div>

            <div className="bg-gray-900 p-6 rounded-2xl border border-gray-800 shadow-lg transform hover:-translate-y-1 transition-transform w-full md:w-1/2" data-id="element-72">
              <div className="text-5xl mb-3" data-id="element-73">📖</div>
              <h3 className="text-4xl font-black text-[#8FF650] mb-1" data-id="element-74">1.500</h3>
              <p className="text-lg font-bold text-white uppercase" data-id="element-75">Ebooks</p>
            </div>
          </div>

          <div className="bg-[#111827] p-6 md:p-8 rounded-2xl border border-[#8FF650]/20 mb-8 shadow-lg" data-id="element-76">
            <p className="text-lg font-bold text-white mb-5" data-id="element-77">
              Con enseñanzas de algunos de los autores más influyentes del
              mundo. Entre ellos:
            </p>

            <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6" data-id="element-78">
              {authors.map((author, idx) => <span key={idx} className="bg-gray-800 px-3 py-1.5 rounded-full border border-gray-700 font-bold text-white shadow-sm text-sm" data-id="element-79">
                  {author}
                </span>)}
              <span className="bg-[#8FF650] text-black px-3 py-1.5 rounded-full font-bold shadow-sm text-sm" data-id="element-80">
                y muchos más...
              </span>
            </div>

            <p className="text-lg md:text-xl font-black text-[#8FF650]" data-id="element-81">
              Miles de horas de conocimiento que normalmente costaría cientos o
              incluso miles de dólares.
            </p>
          </div>

          <div className="flex justify-center" data-id="element-82">
            <CTAButton text="👉 ACCEDER CON DESCUENTO" data-id="element-83" />
          </div>
        </motion.div>
      </div>
    </section>;
}